export default class CopyButton {
  constructor(button, options) {
    this.button = button;
    this.options = {
      textSelector: '.js-copy-button-text',
      valueAttribute: 'copy-button-value',
      messageAttribute: 'copy-button-message',
      copiedClass: 'is-copied',
      copiedMessage: 'Copied!',
      messageDelay: 500,
      ...options,
    };
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick(this.button));
  }

  handleClick(button) {
    const textElement = this.button.querySelector(this.options.textSelector);
    const value = this.button.getAttribute(this.options.valueAttribute);
    if (textElement && value) {
      navigator.clipboard
        .writeText(value)
        .then(() => this.showCopiedState(button))
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    }
  }

  showCopiedState(button) {
    const buttonEl = button;

    buttonEl.style.minWidth = `${buttonEl.offsetWidth}px`;
    buttonEl.classList.add(this.options.copiedClass);
    const originalHTML = buttonEl.innerHTML;
    buttonEl.innerHTML =
      buttonEl.getAttribute(this.options.messageAttribute) || this.options.copiedMessage;

    setTimeout(() => {
      buttonEl.innerHTML = originalHTML;
      buttonEl.classList.remove(this.options.copiedClass);
      buttonEl.style.minWidth = null;
    }, this.options.messageDelay);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-copy-button').forEach((button) => {
    const copyButton = new CopyButton(button);
    copyButton.init();
  });
});
